class MmgsmRecentPurchase extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;

    let products = [];
    try {
      products = JSON.parse(this.dataset.products || '[]');
    } catch (e) {
      products = [];
    }
    products = products.filter((p) => p && p.title && p.url);
    if (products.length === 0) return;

    this.products = products;
    this.probability = Number(this.dataset.probability || 40) / 100;
    this.minIntervalMs = Number(this.dataset.minIntervalMs || 15000);
    this.maxIntervalMs = Math.max(this.minIntervalMs, Number(this.dataset.maxIntervalMs || 40000));
    this.visibleMs = Number(this.dataset.visibleMs || 6000);
    this.minMinutesAgo = Number(this.dataset.minMinutesAgo || 2);
    this.maxMinutesAgo = Math.max(this.minMinutesAgo, Number(this.dataset.maxMinutesAgo || 45));
    this.messageTemplate = this.dataset.message || 'Alguien compró {product} hace {minutes} min';

    this._initialized = true;

    // Igual que mmgsm-social-proof: reparenta a <body> para que
    // position:fixed quede anclado al viewport de verdad.
    document.body.appendChild(this);

    this.scheduleNext();
  }

  disconnectedCallback() {
    clearTimeout(this._nextTimer);
    clearTimeout(this._hideTimer);
  }

  scheduleNext() {
    const delay = this.randomBetween(this.minIntervalMs, this.maxIntervalMs);
    this._nextTimer = setTimeout(() => this.maybeShow(), delay);
  }

  maybeShow() {
    if (Math.random() < this.probability) {
      this.show();
    } else {
      this.scheduleNext();
    }
  }

  show() {
    const product = this.products[Math.floor(Math.random() * this.products.length)];
    const minutes = this.randomBetween(this.minMinutesAgo, this.maxMinutesAgo);
    const text = this.messageTemplate
      .replace('{product}', product.title)
      .replace('{minutes}', String(minutes));

    this.style.bottom = this.computeBottomOffset();
    this.innerHTML = `
      <a class="mmgsm-recent-purchase__card" href="${product.url}">
        <img class="mmgsm-recent-purchase__img" src="${product.image}" alt="" width="40" height="40" loading="lazy">
        <span class="mmgsm-recent-purchase__text"></span>
      </a>
    `;
    this.querySelector('.mmgsm-recent-purchase__text').textContent = text;
    this.classList.add('mmgsm-recent-purchase--visible');

    this._hideTimer = setTimeout(() => this.hide(), this.visibleMs);
  }

  hide() {
    this.classList.remove('mmgsm-recent-purchase--visible');
    this.scheduleNext();
  }

  // Si el aviso de "personas viendo" también está activo en esta página,
  // se posiciona arriba de él en vez de encimarse en la misma esquina.
  computeBottomOffset() {
    const viewers = document.querySelector('mmgsm-social-proof[data-mmgsm-active]');
    if (viewers) {
      const rect = viewers.getBoundingClientRect();
      return `${Math.round(window.innerHeight - rect.top + 12)}px`;
    }
    return '';
  }

  randomBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
}

if (!customElements.get('mmgsm-recent-purchase')) {
  customElements.define('mmgsm-recent-purchase', MmgsmRecentPurchase);
}
